import React, {useEffect, useState} from 'react';
import styles from '../styles/main.module.scss';
import eyeOff from '../assets/eye-off.svg';
import eyeIcon from '../assets/eye.svg';
import useAppDispatch from '../hooks/use-app-dispatch';
import useAppSelector from '../hooks/use-app-selector';
import { setCurrentZoom } from '../store/main-reducer';
import TilesGrid from '../components/TilesGrid';
import {CustomSnackbar} from "../components/SnackBar/SnackBar";
import {useSelector} from "react-redux";
import {RootState} from "../store";
import FullScreenLoader from "../components/Loader/FullScreenLoader";
import SuccessModal from "../components/SuccessModal";
import { useLocation, useNavigate } from "react-router-dom";

const HomePage: React.FC = () => {
  const dispatch = useAppDispatch();
  const { zoom } = useAppSelector((state) => state.mainReducer);
  const { message } = useSelector((state: RootState) => state.snackBarReducer);
  const { isLoading } = useSelector((state: RootState) => state.loaderReducer);
  const [isVisibleSuccessModal, setIsVisibleSuccessModal] = useState(false);
  const [isHiddenGrid, setHiddenGrid] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const success = queryParams.get('success') === 'true';
    if(success){
      setIsVisibleSuccessModal(true);
    }
  }, [])

  const handleSubmitVisibleSuccessModal = async () => {
    setIsVisibleSuccessModal(false);
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.delete('success');
    navigate(`${window.location.pathname}?${queryParams}`, { replace: true });
  };

  const zoomeIn = () => {
    if (zoom <= 2) {
      dispatch(setCurrentZoom(zoom + 0.5));
    }
  };
  const zoomeOut = () => {
    if (zoom >= 1.5) {
      dispatch(setCurrentZoom(zoom - 0.5));
    }
  };
  return (
    <>
      <section className={styles.section}>
        <TilesGrid isHiddenGrid={isHiddenGrid} />
        <div className={styles.buttons}>
          {/*<button onClick={() => setHiddenGrid(!isHiddenGrid)} className={styles.hide}>
            {isHiddenGrid ? (
              <>
                <div className={styles.hide__label}>Show grid</div>
                <div className={styles.hide__icon}>
                  <img src={eyeIcon} alt="closeIcon" />
                </div>
              </>
            ) : (
              <>
                <div className={styles.hide__label}>Hide grid</div>
                <div className={styles.hide__icon}>
                  <img src={eyeOff} alt="closeIcon" />
                </div>
              </>
            )}
          </button>*/}
          {!isHiddenGrid && (
            <div className={styles.scale}>
              <button onClick={() => zoomeOut()} className={styles.scale__buttonMinus}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.25 8.49997C12.25 8.69888 12.171 8.88965 12.0303 9.0303C11.8896 9.17095 11.6989 9.24997 11.5 9.24997H5.49997C5.30106 9.24997 5.11029 9.17095 4.96964 9.0303C4.82899 8.88965 4.74997 8.69888 4.74997 8.49997C4.74997 8.30106 4.82899 8.11029 4.96964 7.96964C5.11029 7.82899 5.30106 7.74997 5.49997 7.74997H11.5C11.6989 7.74997 11.8896 7.82899 12.0303 7.96964C12.171 8.11029 12.25 8.30106 12.25 8.49997ZM19.5306 19.5306C19.4609 19.6003 19.3782 19.6556 19.2872 19.6934C19.1961 19.7311 19.0985 19.7506 19 19.7506C18.9014 19.7506 18.8038 19.7311 18.7128 19.6934C18.6217 19.6556 18.539 19.6003 18.4693 19.5306L13.7762 14.8365C12.1428 16.1971 10.0478 16.8755 7.92691 16.7307C5.80604 16.5859 3.82265 15.629 2.38932 14.0591C0.955989 12.4892 0.183083 10.4271 0.231383 8.30188C0.279683 6.17663 1.14547 4.15181 2.64864 2.64864C4.15181 1.14547 6.17663 0.279683 8.30188 0.231383C10.4271 0.183083 12.4892 0.955989 14.0591 2.38932C15.629 3.82265 16.5859 5.80604 16.7307 7.92691C16.8755 10.0478 16.1971 12.1428 14.8365 13.7762L19.5306 18.4693C19.6003 18.539 19.6556 18.6217 19.6934 18.7128C19.7311 18.8038 19.7506 18.9014 19.7506 19C19.7506 19.0985 19.7311 19.1961 19.6934 19.2872C19.6556 19.3782 19.6003 19.4609 19.5306 19.5306ZM8.49997 15.25C9.83499 15.25 11.14 14.8541 12.2501 14.1124C13.3601 13.3707 14.2253 12.3165 14.7362 11.0831C15.2471 9.84968 15.3807 8.49248 15.1203 7.18311C14.8598 5.87374 14.2169 4.671 13.2729 3.727C12.3289 2.78299 11.1262 2.14012 9.81683 1.87967C8.50746 1.61922 7.15026 1.75289 5.91686 2.26378C4.68346 2.77467 3.62925 3.63984 2.88755 4.74987C2.14585 5.8599 1.74997 7.16495 1.74997 8.49997C1.75196 10.2896 2.46375 12.0053 3.72919 13.2708C4.99463 14.5362 6.71037 15.248 8.49997 15.25Z"
                    fill="#1C5365"
                  />
                </svg>
              </button>
              <button onClick={() => zoomeIn()} className={styles.scale__buttonPlus}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.25 8.49997C12.25 8.69888 12.171 8.88965 12.0303 9.0303C11.8896 9.17095 11.6989 9.24997 11.5 9.24997H9.24997V11.5C9.24997 11.6989 9.17095 11.8896 9.0303 12.0303C8.88965 12.171 8.69888 12.25 8.49997 12.25C8.30106 12.25 8.11029 12.171 7.96964 12.0303C7.82899 11.8896 7.74997 11.6989 7.74997 11.5V9.24997H5.49997C5.30106 9.24997 5.11029 9.17095 4.96964 9.0303C4.82899 8.88965 4.74997 8.69888 4.74997 8.49997C4.74997 8.30106 4.82899 8.11029 4.96964 7.96964C5.11029 7.82899 5.30106 7.74997 5.49997 7.74997H7.74997V5.49997C7.74997 5.30106 7.82899 5.11029 7.96964 4.96964C8.11029 4.82899 8.30106 4.74997 8.49997 4.74997C8.69888 4.74997 8.88965 4.82899 9.0303 4.96964C9.17095 5.11029 9.24997 5.30106 9.24997 5.49997V7.74997H11.5C11.6989 7.74997 11.8896 7.82899 12.0303 7.96964C12.171 8.11029 12.25 8.30106 12.25 8.49997ZM19.5306 19.5306C19.4609 19.6003 19.3782 19.6556 19.2872 19.6934C19.1961 19.7311 19.0985 19.7506 19 19.7506C18.9014 19.7506 18.8038 19.7311 18.7128 19.6934C18.6217 19.6556 18.539 19.6003 18.4693 19.5306L13.7762 14.8365C12.1428 16.1971 10.0478 16.8755 7.92691 16.7307C5.80604 16.5859 3.82265 15.629 2.38932 14.0591C0.955989 12.4892 0.183083 10.4271 0.231383 8.30188C0.279683 6.17663 1.14547 4.15181 2.64864 2.64864C4.15181 1.14547 6.17663 0.279683 8.30188 0.231383C10.4271 0.183083 12.4892 0.955989 14.0591 2.38932C15.629 3.82265 16.5859 5.80604 16.7307 7.92691C16.8755 10.0478 16.1971 12.1428 14.8365 13.7762L19.5306 18.4693C19.6003 18.539 19.6556 18.6217 19.6934 18.7128C19.7311 18.8038 19.7506 18.9014 19.7506 19C19.7506 19.0985 19.7311 19.1961 19.6934 19.2872C19.6556 19.3782 19.6003 19.4609 19.5306 19.5306ZM8.49997 15.25C9.83499 15.25 11.14 14.8541 12.2501 14.1124C13.3601 13.3707 14.2253 12.3165 14.7362 11.0831C15.2471 9.84968 15.3807 8.49248 15.1203 7.18311C14.8598 5.87374 14.2169 4.671 13.2729 3.727C12.3289 2.78299 11.1262 2.14012 9.81683 1.87967C8.50746 1.61922 7.15026 1.75289 5.91686 2.26378C4.68346 2.77467 3.62925 3.63984 2.88755 4.74987C2.14585 5.8599 1.74997 7.16495 1.74997 8.49997C1.75196 10.2896 2.46375 12.0053 3.72919 13.2708C4.99463 14.5362 6.71037 15.248 8.49997 15.25Z"
                    fill="#1C5365"
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
        {message && <CustomSnackbar/>}
        {isLoading && <FullScreenLoader/>}
        {isVisibleSuccessModal && <SuccessModal onClose={handleSubmitVisibleSuccessModal}/>}
      </section>
    </>
  );
};
export default HomePage;
